class QuadraticTextPathGroup extends Konva.Group {
    constructor(config) {
      super(config);

      this.className = 'QuadraticTextPathGroup';
      this.attrs.type = "text";

      //console.log("Test config", config);
      
      this.config = {
        textPath: {
          text: "CUSTOM TEXT CUSTOM TEXT",
          fontSize: 20,
          fontFamily: "Verdana",
          fontStyle: "normal",
          fill: "#1d0200",
          align: "center",
        },
        line: {
          stroke: 'rgba(255, 0, 0, 0.5)',
          strokeWidth: 2,
        },
        linePath: {
          stroke: 'black',
          strokeWidth: 3,
          dash: [10, 10, 0, 10],
          opacity: 0.3,
        },
        anchor: {
          radius: 10,
          stroke: '#666',
          strokeHover: '#080',
          fill: '#ddd',
          strokeWidth: 2,
          strokeWidthHover: 4,
        } 
      };

      this.attrs.draggable = true;
      this.attrs.resizable = false;
      this.attrs.type = "testtextpathgroup";

      this.points = this.buildPoints();
      this.addNodes();
      this.updateDottedLines();
      this.setDraggable(true);
    }

    addNodes() {
      // 'left', 'center', 'right' or 'justify'
      //console.log("this.config.textPath", this.config.textPath);

      let textPath = new Konva.TextPath({
        text: this.config.textPath.text,
        fontSize: this.config.textPath.fontSize,
        fontFamily: this.config.textPath.fontFamily,
        fontStyle: this.config.textPath.fontStyle,
        fill: this.config.textPath.fill,
        align: this.config.textPath.align,
        type: "beziertextpath",
        draggable: false,
        selectable: false
      });
      this.add(textPath);


      // Create bezier curve with custom shape
      let line = new Konva.Shape({
        stroke: this.config.line.stroke,
        strokeWidth: this.config.line.strokeWidth,
        selectable: false,
        sceneFunc: (ctx, shape) => {
          ctx.beginPath();
          ctx.moveTo(this.points.start.x(), this.points.start.y());
          ctx.bezierCurveTo(
            this.points.control.x(),
            this.points.control.y(),
            this.points.end.x(),
            this.points.end.y()
          );
          ctx.fillStrokeShape(shape);
        },
      });
      this.add(line);

      // Create dashed line to show control points for bezier curve
      let linePath = new Konva.Line({
        dash: this.config.linePath.dash,
        strokeWidth: this.config.linePath.strokeWidth,
        stroke: this.config.linePath.stroke,
        lineCap: 'round',
        id: 'bezierLinePath',
        opacity: this.config.linePath.opacity,
        points: [0, 0],
        selectable: false
      });
      this.add(linePath);
    }

    
    getTextPath() {
      const result = this.children.filter((child) => child.getClassName() === "TextPath");
      return result[0];
    }
    

    setAttribute(attr, value) {
      this.attrs[attr] = value;
    }

    buildPoints() {
      return {
        start: this.buildAnchor(60, 30),
        control: this.buildAnchor(240, 110),
        end: this.buildAnchor(80, 160),
      }
    }


    // Function to build anchor point
    buildAnchor(x, y) {
      let that = this;

      const anchor = new Konva.Circle({
        x: x,
        y: y,
        radius: this.config.anchor.radius ,
        stroke: this.config.anchor.stroke,
        fill: this.config.anchor.fill,
        strokeWidth: this.config.anchor.strokeWidth,
        draggable: true,
      });
      this.add(anchor);

      // Add hover styling
      anchor.on('mouseover', function () {
        document.body.style.cursor = 'pointer';
        this.stroke(that.config.anchor.strokeHover);
        this.fill(that.config.anchor.strokeHover);
        this.strokeWidth(that.config.anchor.strokeWidthHover);
      });
      
      anchor.on('mouseout', function () {
        document.body.style.cursor = 'default';
        this.stroke(that.config.anchor.stroke);
        this.fill(that.config.anchor.fill);
        this.strokeWidth(that.config.anchor.strokeWidth);
      });

      // Update curves when anchor is moved
      anchor.on('dragmove', function () {
        that.updateDottedLines();
      });

      return anchor;
    }


    // Function to update dashed line points (showing control points)
    updateDottedLines() {
      const q = this.points;
      const linePath = this.findOne('#bezierLinePath');
      const textPath = this.getTextPath();

      // Update control point lines for bezier curve
      linePath.points([
        q.start.x(),
        q.start.y(),
        q.control.x(),
        q.control.y(),
        q.end.x(),
        q.end.y(),
      ]);

      textPath.data(this.generateSvgPath(
        q.start.x(),
        q.start.y(),
        q.control.x(),
        q.control.y(),
        q.end.x(),
        q.end.y(),
      ));

      transformer.forceUpdate();
    }

    hideControls() {
      this.children.forEach(item => {
        if (item.getClassName() !== "TextPath") {
          item.hide();
        }
      });
    }

    showControls() {
      this.children.forEach(item => {
        item.show();
      });
    }

    generateSvgPath(startX, startY, controlX, controlY, endX, endY) {
      return `M${startX},${startY} Q${controlX},${controlY} ${endX},${endY}`;
    }

    
    getText() {
      return this.getTextPath().getText();
    }

    setText(newText) {
      this.getTextPath().setText(newText);
    } 

    getFontFamily() {
      return this.getTextPath().getFontFamily();
    }

    setFontFamily(newFont) {
      this.getTextPath().setFontFamily(newFont);
    }

    getFontSize() {
      return this.getTextPath().getFontSize();
    }

    setFontSize(newSize) {
      this.getTextPath().setFontSize(newSize);
    }

    getFontStyle() {
      return this.getTextPath().getFontStyle();
    }

    setFontStyle(newStyle) {
      this.getTextPath().setFontStyle(newStyle);
    }

    getLetterSpacing() {
      return this.getTextPath().getLetterSpacing();
    }

    setLetterSpacing(newSpacing) {
      this.getTextPath().setLetterSpacing(newSpacing);
    }
    
  }
  